// extracted by mini-css-extract-plugin
module.exports = {"content":"e_e5","opened":"e_f5","buttonIcon":"e_g5","buttonIconOpen":"e_h5","toggle":"e_i5","collapsible":"e_j5"};